var exports = {
  "uW": "GiftSection.module__section___d3UyVU",
  "xQ": "GiftSection.module__footerContainer___d3UyVU",
  "$P": "GiftSection.module__scrollPromptContainer___d3UyVU",
  "Zq": "GiftSection.module__scrollPromptText___d3UyVU",
  "$O": "GiftSection.module__scrollPromptIcon___d3UyVU",
};

module.exports = exports;
